export default "__VITE_ASSET__54aa807f__"